'use strict';

exports.__esModule = true;
exports.Promise = exports.OdinConcat = undefined;

var _batcher = require('./batcher.js');

var OdinConcat = _interopRequireWildcard(_batcher);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var Promise = OdinConcat.Promise;

exports.OdinConcat = OdinConcat;
exports.Promise = Promise;


//////////////////
// WEBPACK FOOTER
// ./~/@chegg/odin-concat/dist/index.js
// module id = 502
// module chunks = 0